// extracted by mini-css-extract-plugin
module.exports = {"main":"CardsSection1_main__n4CPc","card":"CardsSection1_card__wX3wo","card-img":"CardsSection1_card-img__nYVCT","body-container":"CardsSection1_body-container__vBGSn"};